import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { env } from "../../env";
import {
    setBetStatus,
    setRenderResultStatus,
    setResultTotalNumberKeno,
    fetchLotto12ListBetting,
    addLotto12Betting,
    deleteLotto12Betting,
    lotto12ConfirmBettingNow,
    fetchUserBalance,
    fetchLotto12RecentDraw,
    fetchLotto12DrawingResult,
    fetchLotto12RecentBetReport,
    fetchUserBalanceValidate,
    clearCartLotto12,
    setIsAutoPrint,
    playCountDownAudio,
    playGoodLuckAudio,
    setIsAddToCart,
    fetchStatistic12,
    fetchLotto12RecentBetReportCache
} from "../../store/rootAction";
import { clientAp } from "../../constants/general";
import { SUBSCRIPTION_LOTTO12 } from "../../constants/lotto12";
import swal from "sweetalert";
import { getMute12, toggleMute12 } from "../../utils/cached";
import { Lotto12Context } from "../../store/lotto12/Lotto12Context";
import { setPlayAudio } from "../../store/audio/action";
import { isKp, lotto12CardUrl, cardAudioUrl, cardSmallAudio } from "../../utils/asset";
import { sessionStore } from "../../utils/storage";

class MainDrawingWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            counter: 1,
            bettingId: null,
            showDeleteBetting: false,
            showBetting: false,
            betCode: "",
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betGameRange: "",
            betGameTime: "",
            resultItem: null,
            resultItemRandom: null,
            indexResultItem: 0,
            allNumbers: [],
            timeCount: null,
            numberCode: null,
            winUnderOver: "",
            winOddEven: "",
            winNumber: "",
            winColor: "",
            betMessage: "",
            isShowRecentBet: false,
            recentBetDetail: null,
            isShowValidateBalance: false,
            imgLotto12: "",
            messageValidateBalance: null,
            status: null,
            isStopped: true,
            isStartFlip: false,
            isStoppedJackpot: true,
            showJackpotValue: false,
            isEnableBetNow: true,
            isMute: getMute12() || "OFF",
        };
        this.startDrawing = null;
        this.winTimeout = null;
    }

    componentDidMount() {
        this.subscription();
        this.checkDrawingResult()
        this.props.fetchStatistic12(this.props.stSize);
        this.listenLocalStorage();
        this.getRecentDraw();
        this.props.fetchLotto12ListBetting({ isClear: true })
        this.props.fetchLotto12RecentBetReport()
        this.props.fetchUserBalance();
    }

    componentDidUpdate() {
        if (this.props.isStopBet && this.state.showBetting) {
            this.setState({
                showBetting: false,
                betAmount: 0,
                betGameType: "",
                betGameOdds: "",
                betGameRange: "",
                betGameTime: ""
            })
        }
    }

    componentWillUnmount() {
        if (this.drawingTime) clearTimeout(this.drawingTime)
        this.clearFlipTimers();
    }

    playAudio = (src) => {
        (this.isIframe() && !this.props.appClass) ? this.props.setPlayAudio(src, this.state.isMute) :
            this.props.setPlayAudio(src);
    };

    isIframe = () => this.props.isIframe;

    muteIframe = () => (this.isIframe() && !this.props.appClass) ? this.state.isMute : null;


    listenLocalStorage = () => {
        window.onstorage = () => {
            let mute = getMute12();
            if (mute !== this.state.isMute) {
                this.setState({ isMute: mute });
            }
        }
    }

    toggleMute = () => {
        this.setState((preState) => ({
            isMute: preState.isMute === "OFF" ? "ON" : "OFF"
        }), () => toggleMute12(this.state.isMute));
    }

    onCloseValidateBalance = () => {
        this.setState({
            isShowValidateBalance: false,
            messageValidateBalance: null
        });
    }

    setWinLose = () => {
        let data = this.props.oldResult;
        if (data) {
            const win = {
                winUnderOver: data.underOverCode,
                winOddEven: data.oddEvenCode,
                winNumber: data.numberCode,
                winColor: data.colorCode
            };
            this.setState({
                ...win
            });
        }
    }

    setIsStartFlip = (value) => this.setState({ isStartFlip: value });

    preSetNewGame = () => {
        this.setState({
            winUnderOver: "",
            winOddEven: "",
            winNumber: "",
            winColor: "",
            resultItem: null,
            indexResultItem: 0,
            totalResult: null,
        });
    }


    checkDrawingResult = () => {
        this.props.fetchLotto12DrawingResult()
            .then(() => {
                let countDownTimer = this.props.countDownTimer;
                if (countDownTimer <= 0) {
                    this.props.setRenderResultStatus({ isStopRender: false });
                    this.getReleaseNum();
                }
            });
    }

    subscription = () => {
        clientAp.subscribe({
            query: SUBSCRIPTION_LOTTO12,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_lotto12_drawing) {
                    let currentDraw = event.data.v_lotto12_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    }

    refreshData = () => {
        this.setState({ isStopped: false, showJackpotValue: false });
        this.refresh = setTimeout(() => {
            this.setState({ isStopped: true }, () => clearTimeout(this.refresh));
        }, 13000);
        this.checkDrawingResult();
        this.props.fetchLotto12RecentBetReportCache();
        this.props.fetchUserBalance()
        this.props.fetchLotto12RecentDraw();
        this.preSetNewGame();
        this.props.fetchStatistic12(this.props.stSize);
    }

    onDrawStatusChange = (currentDraw) => {
        if (currentDraw.status !== this.state.status) {
            if (this.state.status && currentDraw.status === "OPEN") {
                this.refreshData();
            }
            if (currentDraw.status === "RELEASE") this.props.fetchLotto12DrawingResult().then(() => this.getReleaseNum());
            this.setState({ status: currentDraw.status });
        }
        this.verifyCurrentDraw(currentDraw.drawCode);
    }

    verifyCurrentDraw = currentDrawCode => {
        let betList = sessionStore.get("betting_lotto12", []);
        if (betList.length) {
            let firstItem = betList[0];
            if (firstItem.drawCode !== currentDrawCode) {
                this.props.clearCart();
            }
        }

    }

    getReleaseNum = () => this.setIsStartFlip(true);

    drawResult = (indexNumber) => {
        let { resultItem, allNumbers } = this.props.oldResult.lottoDraw;
        this.setState({
            resultItem: resultItem[indexNumber],
            indexResultItem: indexNumber,
            allNumbers: allNumbers,
            classNameNumberDraw: "lotto12-show-number-draw",
            classNameLogoRender: "lotto12-hide-logo-render",
            classCountDown: "lotto12-total-result-render-count-total"
        })

    }


    countingSecond = (count) => {
        if (this.props.countDownTimer < 0) {
            this.props.setRenderResultStatus({ isStopRender: true })
        } else {
            if (count >= this.closeBet) {
                this.setState({ classCountDown: "lotto12-total-result-render-count" });
            } else if (count < this.props.closeBet && count > 0) {
                this.props.setBetStatus({ isStopBet: true });
                this.props.playCountDownAudio(count, this.muteIframe());
                this.setState({ classCountDown: "lotto12-total-result-render-count-warning" })
            } else if (count === 0) {
                this.props.playGoodLuckAduio(this.muteIframe());
                this.props.setRenderResultStatus({ isStopRender: false });
                this.setState({ classCountDown: "lotto12-total-result-render-count-total" })
                this.props.clearCart();
            }
        }
    }

    getRecentDraw = () => {
        this.props.fetchLotto12RecentDraw();
    }

    getResultDrawing = () => {
        this.props.fetchLotto12DrawingResult()
            .then(() => {
                this.getReleaseNum();
            })
    }

    onBetting = (item) => {
        const { isStopBet, fetchUserBalanceValidate, t } = this.props;
        if (!isStopBet) {
            fetchUserBalanceValidate()
                .then(() => {
                    this.setState({
                        showBetting: true,
                        betGameType: item.name,
                        betGameOdds: item.value,
                        betGameRange: item.resultRange,
                        betCode: item.code,
                        betGameTime: moment(new Date()).format('HH:mm:ss')
                    });
                }).catch(error => {
                    this.setState({
                        isShowValidateBalance: true,
                        messageValidateBalance: t("labels:common." + error.response.data.message)
                    });
                })
        }
    }

    onConfirmBetting = async (logs) => {
        const { user: { isAddToCart }, newResult } = this.props
        const {
            betCode,
            betAmount,
            betGameOdds
        } = this.state;
        const data = {
            drawCode: newResult.drawCode,
            betTypeCode: betCode,
            amount: betAmount,
            betLog: logs,
            rebateRate: betGameOdds
        }
        await this.props.addLotto12Betting(data);
        !isAddToCart && this.submitBetNow();

        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: '',
            betGameOdds: '',
            betMessage: "",
            betGameRange: "",
            betGameTime: ""
        })
    }

    onCancelBetting = () => {
        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: '',
            betGameOdds: '',
            betMessage: "",
            betGameRange: "",
            betGameTime: ""
        })
    }

    showConfirmDelete = (id) => {
        this.setState({ showDeleteBetting: false, bettingId: null });
        this.props.deleteLotto12Betting({ id: id });
    }

    submitBetNow = () => {
        const { isEnableBetNow } = this.state;
        const { user } = this.props;
        isEnableBetNow && this.props.lotto12ConfirmBettingNow(() => this.setState({ isEnableBetNow: false }))
            .then(() => {
                this.setState({ isEnableBetNow: true })
                this.props.fetchLotto12RecentBetReport().then(() => user.isAutoPrint && document.getElementById("print-button").click());
                this.props.fetchUserBalance();
            }).catch((error) => {
                const { response } = error;
                this.setState({ isEnableBetNow: true })
                response && swal(response.data.message, { icon: "error", button: "បិទ" });
            })
    }


    clickAmountBetBtn = (amount) => {
        let betAmount = this.state.betAmount || 0;

        this.setState({
            betAmount: parseInt(betAmount) + amount,
        })
    }

    resetDefaultAmount = () => {
        this.setState({ betAmount: 0 })
    }

    changeBetAmount = (e) => {
        if (e.target.value >= 0 || !isNaN(e.target.value) || e.target.value === undefined) {
            this.setState({ betAmount: e.target.value })
        }
    }

    setBetMessage = (message = "") => {
        this.setState({ betMessage: message })
    }

    getTotalCartAmount = () => {
        return this.props.fetchLotto12ListBetting({ isClear: false }) || 0;
    }

    clearFlipTimers = () => {
        this.startDrawing && clearInterval(this.startDrawing);
        this.winTimeout && clearTimeout(this.winTimeout);
    }

    runFlipAnimation = () => {
        const { oldResult } = this.props;
        const { isStartFlip, isStopped } = this.state;
        const lottoDraw = oldResult?.lottoDraw;
        if (!isStartFlip || !lottoDraw) {
            this.clearFlipTimers();
            return;
        }


        if (isStopped) {
            const drawingItem = lottoDraw.items.filter(e => e.isDrawRelease === 1);
            let index = lottoDraw.items.indexOf(drawingItem[0]);

            lottoDraw.items.forEach((e, i) => {
                if (e.isDrawRelease === 0) {
                    const doc = document.getElementById(`card-inner-${i}`);
                    if (doc) {
                        doc.classList.add("flip-180");
                    }
                    if (i === 10) {
                        const docResult = document.getElementById(`card-inner-result`);
                        if (docResult) docResult.classList.add("flip-180");
                    }
                }
                const img = document.getElementById(`img-${i}`);
                if (img) img.src = lotto12CardUrl(e?.numberCode);
            });

            const imgResult = document.getElementById(`img-result`);
            if (imgResult) imgResult.src = lotto12CardUrl(lottoDraw?.resultNumber);

            this.clearFlipTimers();
            this.startDrawing = setInterval(() => {
                const doc = document.getElementById(`card-inner-${index}`);

                if (doc && !doc.classList.contains("flip-180")) {
                    this.playAudio(cardSmallAudio);
                    doc.classList.add("flip-180");
                }
                if (index >= 10) {
                    const docResult = document.getElementById(`card-inner-result`);
                    if (docResult) docResult.classList.add("flip-180");
                    !isKp() && this.playAudio(cardAudioUrl(lottoDraw?.resultNumber));
                    setTimeout(() => {
                        this.setWinLose();
                    }, 1000);
                    this.clearFlipTimers();
                    this.setIsStartFlip(false);
                }
                index++;

            }, 1400);
        }
    }

    countDownCallBack = (count) => {
        if (this.state.winNumber !== "" && count > 0) {
            this.checkDrawingResult();
            this.preSetNewGame();
            this.setIsStartFlip(false);
            return true;
        } else return false;
    }

    render() {
        const contextValue = {
            platform: env.PLATFORM_FOR,
            platformType: env.PLATFORM_TYPE,
            ...this.props,
            ...this.state,
            onCloseValidateBalance: this.onCloseValidateBalance,
            setWinLose: this.setWinLose,
            preSetNewGame: this.preSetNewGame,
            checkDrawingResult: this.checkDrawingResult,
            subscription: this.subscription,
            onDrawStatusChange: this.onDrawStatusChange,
            getReleaseNum: this.getReleaseNum,
            drawResult: this.drawResult,
            refreshData: this.refreshData,
            countingSecond: this.countingSecond,
            getRecentDraw: this.getRecentDraw,
            getResultDrawing: this.getResultDrawing,
            onBetting: this.onBetting,
            onConfirmBetting: this.onConfirmBetting,
            onCancelBetting: this.onCancelBetting,
            showConfirmDelete: this.showConfirmDelete,
            submitBetNow: this.submitBetNow,
            clickAmountBetBtn: this.clickAmountBetBtn,
            resetDefaultAmount: this.resetDefaultAmount,
            changeBetAmount: this.changeBetAmount,
            setBetMessage: this.setBetMessage,
            getTotalCartAmount: this.getTotalCartAmount,
            setIsStartFlip: this.setIsStartFlip,
            toggleMute: this.toggleMute,
            playAudio: this.playAudio,
            runFlipAnimation: this.runFlipAnimation,
            clearFlipTimers: this.clearFlipTimers,
            countDownCallBack: this.countDownCallBack,
            tenSecondCallback: this.countingSecond

        };
        return (
            <Lotto12Context.Provider value={contextValue}>
                {this.props.children}
            </Lotto12Context.Provider>
        );
    }
}

const mapStateToProps = state => ({
    ...state.lotto12,
    user: state.user,
    audio: state.audio,
    config: state.config
});

const mapDispatchToProps = dispatch => ({
    setBetStatus: payload => dispatch(setBetStatus(payload)),
    setRenderResultStatus: payload => dispatch(setRenderResultStatus(payload)),
    setResultTotalNumber: payload => dispatch(setResultTotalNumberKeno(payload)),
    fetchLotto12DrawingResult: () => dispatch(fetchLotto12DrawingResult()),
    fetchLotto12RecentDraw: payload => dispatch(fetchLotto12RecentDraw(payload)),
    fetchLotto12RecentBetReport: () => dispatch(fetchLotto12RecentBetReport()),
    fetchLotto12RecentBetReportCache: () => dispatch(fetchLotto12RecentBetReportCache()),
    fetchUserBalance: () => dispatch(fetchUserBalance()),
    fetchUserBalanceValidate: () => dispatch(fetchUserBalanceValidate()),
    setIsAutoPrint: payload => dispatch(setIsAutoPrint(payload)),
    playCountDownAudio: (index, isMute) => dispatch(playCountDownAudio(index, isMute)),
    playGoodLuckAduio: (isMute) => dispatch(playGoodLuckAudio(isMute)),
    fetchStatistic12: payload => dispatch(fetchStatistic12(payload)),
    addLotto12Betting: payload => dispatch(addLotto12Betting(payload)),
    deleteLotto12Betting: payload => dispatch(deleteLotto12Betting(payload)),
    lotto12ConfirmBettingNow: (callback) => dispatch(lotto12ConfirmBettingNow(() => callback())),
    fetchLotto12ListBetting: payload => dispatch(fetchLotto12ListBetting(payload)),
    clearCart: () => dispatch(clearCartLotto12()),
    setIsAddToCart: payload => dispatch(setIsAddToCart(payload)),
    setPlayAudio: payload => dispatch(setPlayAudio(payload)),
});

export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps
)(MainDrawingWrapper));
